"use client"

import { useEffect, useState } from "react"
import { User, Target, Award, BarChart3 } from "lucide-react"

export default function CMIDesign() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Initial check
    checkIfMobile()

    // Add event listener for window resize
    window.addEventListener("resize", checkIfMobile)

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkIfMobile)
    }
  }, [])

  return (
    <div className="min-h-screen  flex flex-col items-center justify-center bg-[#6A2f38] p-6" >
      <div className="container  text-white rounded-lg">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-bold mb-2">تصميم البرنامج</h1>
          <div className="w-24 h-0.5 bg-[#e6c9a8] mx-auto mb-6"></div>

          <p className="text-sm md:text-base leading-relaxed mb-4">
          يتم تنظيم برنامج المدير المعتمد حول المعيار المهني لمعهد الإدارة المعتمدة (CMI)، وهو إطار شامل تم تطويره بواسطة معهد الإدارة المعتمدة لتوضيح المهارات والكفاءات الأساسية للمديرين والقادة. مستندًا إلى أكثر من 75 عامًا من الخبرة، يساعد هذا الإطار الأفراد في مختلف مراحل حياتهم المهنية على تقييم وتطوير قدراتهم. يتم تنظيم البرنامج في مجالات رئيسية تتماشى مع عجلة المعيار المهني لمعهد الإدارة المعتمد، مما يضمن نهجًا شاملاً لتطوير الإدارة والقيادة
              </p>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1 */}
          <div className="border border-[#8a4555] rounded-lg p-6 relative mt-4">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#e6c9a8] rounded-full p-3">
              <User className="w-6 h-6 text-[#6d2c3e]" />
            </div>
            <h2 className="text-xl font-bold text-center mt-4 mb-6">التميز الشخصي</h2>
            <ul className="space-y-2 text-right">
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">توفير الهدف والتخطيط وإدارة التغيير</span>
              
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">تطوير الأفراد والقدرات ومبادئ تقديم التدريب والإرشاد</span>
                
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">بناء العلاقات والشبكات وإدارة علاقات الأطراف المعنية</span>
          
              </li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="border border-[#8a4555] rounded-lg p-6 relative mt-4">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#e6c9a8] rounded-full p-3">
              <Target className="w-6 h-6 text-[#6d2c3e]" />
            </div>
            <h2 className="text-xl font-bold text-center mt-4 mb-6">الفعالية الشخصية والتميز الشخصي</h2>
            <ul className="space-y-2 text-right">
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">إدارة الذات واستخدام الممارسة التأملية لإدارة التطوير الشخصي والمهني</span>
                
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">اتخاذ القرارات واستخدام البيانات والمعلومات لاتخاذ القرارات</span>
                
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">التواصل والتأثير وإدارة نبرة الصوت</span>
                
              </li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className="border border-[#8a4555] rounded-lg p-6 relative mt-4">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#e6c9a8] rounded-full p-3">
              <Award className="w-6 h-6 text-[#6d2c3e]" />
            </div>
            <h2 className="text-xl font-bold text-center mt-4 mb-6">القيادة الأخلاقية والشاملة</h2>
            <ul className="space-y-2 text-right">
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">إدارة المساواة والتنوع والشمول</span>
               
              </li>
            </ul>
          </div>

          {/* Card 4 */}
          <div className="border border-[#8a4555] rounded-lg p-6 relative mt-4">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#e6c9a8] rounded-full p-3">
              <BarChart3 className="w-6 h-6 text-[#6d2c3e]" />
            </div>
            <h2 className="text-xl font-bold text-center mt-4 mb-6">الأداء التنظيمي والقيادة الأخلاقية والشاملة</h2>
            <ul className="space-y-2 text-right">
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">قيادة التغيير والابتكار ومبادئ الابتكار</span>
               
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">إدارة الموارد والمخاطر وإدارة المالية</span>
             
              </li>
              <li className="flex items-center justify-start gap-2">
              <span className="text-[#e6c9a8]">•</span>
                <span className="text-sm">تحقيق النتائج وتنفيذ مشروع إداري</span>
               
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
